<template>
    <el-button type="primary" size="small" circle>
        <ComTooltip content="Liitteet">
            <el-icon>
                <Paperclip></Paperclip>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { Paperclip } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Paperclip,
        ComTooltip,
    },
})
</script>
